module.exports = "/_next/static/images/app-store-promo-c7a91ab1a6e531515341531a24a7853c.svg";